module.exports = __webpack_public_path__ + "quicksilver/static/media/idbi.cf6caf2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/banking/idbi.svg
// module id = 643
// module chunks = 0